export class XmlFilePathHelper {
  // Fax outreach packets store their generated file paths as a <filepath> list in an XML blob;
  // this finds the entry whose path contains the given file name.
  static extractFilePath(xmlString: string, fileName: string): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");
    const pathElements = Array.from(xmlDoc.getElementsByTagName("filepath"));
    const match = pathElements.find(path => path.textContent && path.textContent.includes(fileName));
    return match?.textContent ?? "";
  }
}
